import type { UseWidget } from '@swf/core/hooks/useWidget';
import { useWidget } from '@swf/core/hooks/useWidget';
import type { WidgetModelConfig } from '@swf/core/store';

import type { SportsCompetitionEventsWidgetConfig } from '../config';

import { defaultState } from './defaultState';
import { effects } from './effects';
import { reducers } from './reducers';
import { selectors } from './selectors';

export interface SportsCompetitionEventsWidgetModel
  extends WidgetModelConfig<SportsCompetitionEventsWidgetConfig, typeof defaultState> {
  reducers: typeof reducers;
  effects: typeof effects;
  selectors: typeof selectors;
}

export const sportsCompetitionEventsWidgetModel: SportsCompetitionEventsWidgetModel = {
  state: defaultState,
  reducers,
  effects,
  selectors
};

export const useSportsCompetitionEventsWidget: UseWidget<
  SportsCompetitionEventsWidgetConfig,
  SportsCompetitionEventsWidgetModel
> = useWidget;
